// Single source of truth for Flightdeck versioning.
//
// On every change: bump BUILD_VERSION to the current YYYYMMDDHHMM, bump APP_VERSION (semver)
// and package.json to match, and add a CHANGELOG.md entry. BUILD_VERSION is shown in the
// sidebar footer so any deployed instance can be recalled against the changelog.

export const APP_VERSION = '0.88.0';
export const BUILD_VERSION = '202609221000';
export const APP_NAME = 'Flightdeck';
